import { PriceGroup, Price } from '@printdeal/product-selector';
import { GroupSelection } from '../types/selector/Selector';

export const pricePivotAttributes = ['Printing Process', 'Delivery Type'];
/**
 * Get the centAmount of a price/discount object.
 */
export const getPriceAmount = (vatMode: 'totalNet' | 'totalGross', price: Price, discountedPrice?: Price): number => {
  if (!discountedPrice) {
    return price[vatMode].centAmount;
  }
  // TODO: Can't we simply always return the discounted price?
  if (price[vatMode].centAmount === discountedPrice[vatMode].centAmount) {
    return price[vatMode].centAmount;
  }
  return discountedPrice[vatMode].centAmount;
};

export const formatAttributes = (attributes: [string, string][]) =>
  attributes.map(([name, value]) => ({ name, value }));

export const getPriceGroups = (groups: GroupSelection[]): PriceGroup[] => groups.map((group) => ({
  attributes: formatAttributes(Object.entries(group.attributes)),
  quantity: Number(group.quantity),
}));
